
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientwarningsystem() {



  const cardData =
  {
    keyword: 'Patient Warming Systems in Chennai',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Systems in Chennai',
    headingDescription: 'Pharmacle Health Care Private Limited provides advanced Patient Warming Systems in Chennai, ensuring optimal temperature management for surgical and critical care patients. Our Wallabies Warm Care systems are designed to deliver uniform and efficient warming, reducing the risk of hypothermia and enhancing patient recovery. Trusted by hospitals and healthcare professionals, our patient warming systems are safe, reliable, and easy to use. With cutting-edge technology and superior quality, we help improve patient outcomes. Choose Pharmacle Health Care for the best patient warming solutions in Chennai.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

   "topPlaces": [
  {
    "title": "Advanced Patient Warming System in Chennai",
    "description": "Pharmacle Health Care Private Limited provides cutting-edge Patient Warming Systems in Chennai, designed to ensure precise temperature regulation during surgeries and medical procedures. Our systems help reduce the risk of hypothermia and improve patient safety."
  },
  {
    "title": "Forced Air Warming System for Hospitals & ICUs",
    "description": "Our advanced Forced Air Warming System delivers consistent and controlled warm air to patients, helping maintain normothermia in operating rooms, intensive care units, and emergency departments."
  },
  {
    "title": "Surgical Patient Warming Blanket in Chennai",
    "description": "Pharmacle Health Care Private Limited offers Surgical Patient Warming Blankets compatible with forced air warming units. These blankets ensure even heat distribution, enhancing patient comfort and safety during operations."
  },
  {
    "title": "Portable Patient Warming Unit for Emergency Care",
    "description": "Our Portable Patient Warming Unit is ideal for mobile medical units, ambulances, and field hospitals. It enables quick deployment and efficient temperature management for trauma and emergency cases in Chennai."
  },
  {
    "title": "Neonatal Patient Warming System for NICUs",
    "description": "Specially designed for newborns, our Neonatal Patient Warming Systems ensure precise and gentle thermal regulation. Pharmacle Health Care Private Limited supports NICUs and maternity wards in preventing neonatal hypothermia."
  },
  {
    "title": "Preoperative and Postoperative Patient Warming System",
    "description": "Our pre- and post-surgery warming systems keep patients warm before and after surgical procedures, reducing complications and promoting faster recovery outcomes."
  },
  {
    "title": "ICU Patient Warming System in Chennai",
    "description": "Pharmacle Health Care Private Limited provides ICU-grade Patient Warming Systems that deliver controlled thermal support to critically ill patients. These systems stabilize body temperature and improve recovery rates."
  },
  {
    "title": "Veterinary Patient Warming System for Animal Care",
    "description": "Extending beyond human healthcare, our Veterinary Patient Warming Systems ensure safe and reliable warming solutions for pets and livestock undergoing medical treatments or surgeries."
  },
  {
    "title": "Temperature-Controlled Air Warming System",
    "description": "This advanced temperature-controlled system offers customizable heat settings, making it suitable for operating theaters, ICUs, and recovery wards across Chennai’s leading hospitals."
  },
  {
    "title": "Emergency Medical Patient Warming System",
    "description": "Pharmacle Health Care Private Limited provides emergency warming systems essential for trauma care. These devices help stabilize patients in critical conditions by preventing hypothermia and ensuring optimal body temperature."
  }
],


"services": [
    {
        "name": "Patient Warming Systems Chennai",
        "description": "Pharmacle Health Care Private Limited offers advanced patient warming systems in Chennai, designed to regulate and maintain a safe and comfortable body temperature during surgeries, critical care, and post-operative recovery."
    },
    {
        "name": "Chennai Patient Warming Devices",
        "description": "Our patient warming devices in Chennai ensure precise temperature control for patients during medical procedures, reducing the risk of hypothermia and improving recovery times for patients in critical care and surgery settings."
    },
    {
        "name": "Forced Air Warming System Chennai",
        "description": "Pharmacle Health Care provides reliable forced air warming systems in Chennai, designed to offer effective temperature regulation for patients during surgeries and medical treatments, ensuring patient comfort and safety."
    },
    {
        "name": "Chennai Patient Thermoregulation Equipment",
        "description": "We offer patient thermoregulation equipment in Chennai that helps maintain an optimal body temperature for patients, ensuring safety and comfort during medical treatments, surgeries, and post-operative care."
    },
    {
        "name": "Medical Warming Systems Chennai",
        "description": "Our medical warming systems in Chennai are designed to regulate patient body temperature during surgeries, preventing hypothermia and ensuring a stable and comfortable environment for patients undergoing medical procedures."
    },
    {
        "name": "Patient Warming Device Supplier Chennai",
        "description": "Pharmacle Health Care is a trusted supplier of patient warming devices in Chennai. We provide high-quality devices that deliver consistent and reliable temperature control to enhance patient comfort and safety during medical procedures."
    },
    {
        "name": "Chennai Temperature Management Solutions",
        "description": "We offer comprehensive temperature management solutions in Chennai, including patient warming devices and thermoregulation systems, to ensure that patients are maintained at a safe and comfortable temperature during medical care."
    },
    {
        "name": "Chennai Warming System for Hospitals",
        "description": "Pharmacle Health Care supplies hospital warming systems in Chennai, designed to effectively regulate patient body temperature during surgeries, emergency care, and recovery. Our systems ensure that patients remain comfortable and safe throughout their treatment."
    }
],
"tableData": [
    ["- Patient Warming Systems Chennai", "- Chennai Patient Warming Devices"],
    ["- Forced Air Warming System Chennai", "- Chennai Patient Thermoregulation Equipment"],
    ["- Medical Warming Systems Chennai", "- Patient Warming Device Supplier Chennai"],
    ["- Chennai Temperature Management Solutions", "- Chennai Warming System for Hospitals"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited provides advanced forced air warming systems in Chennai, offering precise temperature control during medical procedures. Our technology ensures reliable performance to prevent hypothermia, improving patient safety across hospitals and clinics in the city."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a wide range of patient warming solutions in Chennai, including forced air warming devices, blankets, and temperature control systems. Our solutions are designed to meet the needs of both surgical procedures and critical care, ensuring patient comfort and safety throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming equipment is manufactured to the highest quality standards, ensuring long-lasting performance and durability. Regularly tested and maintained, our systems offer optimal reliability for continuous use in medical settings in Chennai."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our forced air warming blankets and devices provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Chennai are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming systems in Chennai are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We collaborate closely with healthcare providers to ensure that our systems meet their specific needs and improve overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care's patient warming solutions are designed for easy integration with existing medical systems in Chennai. Our products can be quickly implemented without disrupting ongoing medical procedures, ensuring an efficient and smooth experience for healthcare professionals."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "Our team offers expert consultation services in Chennai to help healthcare facilities select the right patient warming solutions. We also provide ongoing support and maintenance services to ensure that your equipment remains in peak condition for optimal performance."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the heart of our mission. Our warming systems are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Chennai receives the highest level of care."
    }
]





  }



  const faqData = [
    { question: "What is a Patient Warming System?", answer: "A Patient Warming System is a medical device that helps maintain or regulate a patient's body temperature during surgeries or medical procedures by providing controlled warm air through blankets or other heating devices." },
    { question: "How does a Patient Warming System work?", answer: "The system works by circulating warm air through a specially designed blanket or pad, ensuring that the patient’s body temperature remains stable during surgeries or treatments, which is crucial for preventing hypothermia." },
    { question: "Is the Patient Warming System available in Chennai?", answer: "Yes, Pharmacle Health Care Private Limited offers the Patient Warming System in Chennai to ensure healthcare providers have access to high-quality patient temperature management solutions." },
    { question: "What are the key benefits of using a Patient Warming System?", answer: "The system helps prevent hypothermia, reduces surgical site infections, speeds up patient recovery, and improves overall comfort during medical procedures." },
    { question: "How long can the Patient Warming System maintain a patient's temperature?", answer: "The system can maintain the patient’s temperature for the entire duration of the medical procedure, adjusting as needed based on the patient's condition." },
    { question: "Is the Patient Warming System easy to operate?", answer: "Yes, the system is designed for ease of use, with intuitive controls that allow healthcare professionals to quickly set the appropriate temperature for patient comfort." },
    { question: "Can the Patient Warming System be used for all types of surgeries?", answer: "Yes, the Patient Warming System is versatile and can be used for various types of surgeries and treatments, especially those where maintaining body temperature is crucial." },
    { question: "Is the Patient Warming System safe for all patients?", answer: "Yes, the system is safe for most patients, but it should be used under the supervision of trained healthcare professionals to ensure proper temperature management." },
    { question: "How can I purchase a Patient Warming System in Chennai?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with the purchase and delivery process in Chennai." },
    { question: "Does Pharmacle Health Care provide support for the Patient Warming System?", answer: "Yes, we offer installation, training, and ongoing maintenance support for our Patient Warming Systems to ensure they continue to function optimally." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Warming System in our hospital in Chennai, and it has made a significant difference in patient outcomes. The system ensures that our patients are kept at an optimal temperature during surgeries.',
      name: 'Dr. Vikram Rajan',
    },
    {
      text: 'The Patient Warming System from Pharmacle Health Care has been a valuable addition to our clinic in Chennai. It’s easy to use, reliable, and ensures the safety and comfort of our patients throughout their procedures.',
      name: 'Dr. Priya Sundaram',
    }
  ];
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warming Systems in Chennai",
    "description": "Explore advanced Patient Warming Systems in Chennai for effective thermoregulation and temperature management in hospitals and clinics. Our medical warming devices ensure patient comfort during surgeries and treatments.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "1320"
    }
  };
  

  

  return (
    <div>
  <Helmet>
    <title>Patient Warming Systems in Chennai | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore advanced Patient Warming Systems in Chennai for patient thermoregulation and temperature management in hospitals. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warming Systems Chennai, Chennai Patient Warming Devices, Forced Air Warming System Chennai, Chennai Patient Thermoregulation Equipment, Medical Warming Systems Chennai, Patient Warming Device Supplier Chennai, Chennai Temperature Management Solutions, Chennai Warming System for Hospitals"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/4.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientwarningsystem;